/**
 * Submission revisions distinguish courses whose earlier input tapes must be retired.
 * Missing revisions from older clients mean revision 1. Increment a course when changing its
 * layout so queued runs cannot be replayed against different geometry on its new leaderboard.
 */
export function courseRevision(name: string): number {
  if (name === "descent") return 3;
  return name === "gauntlet" ? 2 : 1;
}
